import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { getEmbedUrl, getStrategySession } from '../services/api'
import MetabaseEmbed from '../components/MetabaseEmbed'
import rhythmicLogo from '../assets/rhythmic-logo-white.svg'

function CompanyDashboard() {
  const navigate = useNavigate()
  const { user, groups, signOut } = useAuth()
  const [embedUrl, setEmbedUrl] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  const isAdmin = groups.includes('admin')
  const isLeadership = groups.includes('admin') || groups.includes('leadership')

  useEffect(() => {
    async function fetchEmbedUrl() {
      setIsLoading(true)
      setError(null)
      try {
        const url = await getEmbedUrl('company')
        setEmbedUrl(url)
      } catch (err) {
        setError('Failed to load dashboard. Please try again.')
        console.error('Failed to get embed URL:', err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchEmbedUrl()
  }, [])

  function handleViewLeadership() {
    navigate('/leadership')
  }

  async function handleOpenStrategy() {
    try {
      const session = await getStrategySession()
      window.location.assign(session.url)
    } catch (err) {
      setError('Failed to open Strategy. Please try again.')
      console.error('Failed to get strategy session:', err)
    }
  }

  return (
    <>
      <header className="header">
        <div className="header-brand">
          <img src={rhythmicLogo} alt="Rhythmic" className="header-logo" />
          <span className="header-title">How We're Doing</span>
        </div>
        <div className="header-right">
          <span>{user?.email}</span>
          <span className="badge">Company</span>
          <button className="btn btn-secondary" onClick={handleOpenStrategy}>
            Strategy
          </button>
          {isLeadership && (
            <button className="btn btn-secondary" onClick={handleViewLeadership}>
              Leadership View
            </button>
          )}
          {isAdmin && (
            <button className="btn btn-secondary" onClick={() => navigate('/admin/users')}>
              Admin
            </button>
          )}
          <button className="btn btn-secondary" onClick={signOut}>
            Sign out
          </button>
        </div>
      </header>

      <main className="main">
        {error ? (
          <div className="error">{error}</div>
        ) : isLoading ? (
          <div className="loading">Loading dashboard...</div>
        ) : embedUrl ? (
          <MetabaseEmbed url={embedUrl} />
        ) : null}
      </main>
    </>
  )
}

export default CompanyDashboard
